import { quizBankApiServerUrl, logServerUrl, bannedWatchersUrl } from '@/config'
import l from '@/vendor/logger'

export default function apiService ({ url, token, method, body, resource, slug, params, isAdminLog }) {
  let headers = new Headers()
  headers.append('Content-Type', 'application/json')
  if (token) {
    headers.append('token', token)
  }
  if (isAdminLog) {
    headers.append('X-Admin-Log', '1')
  }
  return fetch(
    slug
      ? `${url}/${resource}/${slug}`
      : `${url}/${resource}`,
    {
      method,
      headers,
      mode: 'cors',
      cache: 'default',
      body
      // params ? params : undefined
    }).then((response) => {
    if (response.ok) {
      l.d(`apiService/${resource}/${slug}?${method}`, response)
      return response
    } else {
      throw new Error(`apiService/${resource}/${slug}?${method}`, response.statusText, response)
    }
  })
}

export function quizBankApiService ({ token, method, body, params, slug }) {
  return apiService({
    url: quizBankApiServerUrl,
    resource: 'quizzes',
    slug,
    token,
    method,
    body,
    params
  })
}

export function logService ({ method, body, isAdminLog }) {
  return apiService({
    url: logServerUrl,
    method,
    body,
    isAdminLog,
    resource: ''
  })
}

export function bannedWatchersApiService ({ token, method, body, params, slug }) {
  return apiService({
    url: bannedWatchersUrl,
    resource: 'quizzes',
    slug,
    token,
    method,
    body,
    params
  })
}
